import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import OneVerseLogo from '../../../components/OneVerseLogo';
import { Button } from '@/components/ui/button';

interface RegistrationSuccessProps {
  // True when the account was approved on confirmation (invited by a
  // Submission/Site/Study Manager), so there is no Univo review to wait for.
  approved?: boolean;
}

const RegistrationSuccess: React.FC<RegistrationSuccessProps> = ({
  approved = false,
}) => {
  const { t } = useTranslation();

  return (
    <div>
      <OneVerseLogo className="mb-6 mt-2 mx-auto" />
      <div className="text-center mt-4">
        <h1 className="text-2xl font-semibold text-gray-900 mb-4">
          {approved
            ? t('auth.registration_success.approved_title')
            : t('auth.registration_success.title')}
        </h1>
        <p className="text-gray-600">
          {approved
            ? t('auth.registration_success.approved_body')
            : t('auth.registration_success.pending_review')}
        </p>
        {approved && (
          <Button asChild className="mt-6">
            <Link to="/login">{t('auth.registration_success.sign_in')}</Link>
          </Button>
        )}
      </div>
    </div>
  );
};

export default RegistrationSuccess;
